<template lang="pug">
div.divPage  
  md-layout.error-page(md-column='')
    div.logoContainer
      img(src='../assets/img/RhebusTV_logo.jpg', md-align='center', width='350px')
    md-layout(md-align='center')
      div.error-card(md-elevation='3')
        h1 404
        p.alert
          md-icon.on-left.md-accent()
          | Oops. Nothing here...
        md-button.md-primary.md-raised(v-if='canGoBack', @click='goBack')
          md-icon.colorIcons(md-iconset="fa fa-arrow-left")
          | Go back
        router-link(to='/')
          md-button.md-primary.md-raised
            | Go home
            md-icon.colorIcons.on-right(md-iconset="fa fa-home")
</template>

<script>
  export default {
    data() {
      return {
        canGoBack: window.history.length > 1
      };
    },
    methods: {
      goBack() {
        window.history.go(-1);
      }
    }
  };
</script>

<style lang="scss" scoped>
  $background: #FA3348;
  .md-raised{
    background-color: rgb(0, 0, 0) !important;
  }
  .logoContainer{
    margin: auto;
    margin-bottom: 30px;
  }
  .colorIcons{
    color: rgba(255, 255, 255, .87) !important;
  }
  .divPage{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
  .error-page {
    .error-code {
      background-color: $background;
      height: 50vh;
      width: 100%;
      padding-top: 25vh;
      font-size: 30vmax;
      color: rgba(255, 255, 255, 0.2);
      overflow: hidden;
    }
    .error-card {
      text-align: center;
      margin-top: 5px;
      width: 90vh;
      max-width: 600px;
      padding: 40px;
      .alert {
        font-size: 1.6em;
        .on-left {
          margin-right: 10px;
          margin-top: -5px;
          font-size: 1.4em;
          color: $background;
        }
      }
      .on-right {
        margin-left: 5px;
        margin-top: -4px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/NotFound.vue